import { useMemo } from 'react';
import { WhiteLabelAccessor } from 'utils/whiteLabelAccessor';
import { ChartColorPalette } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors/chartColors.types';
import {
  bookjanePalette,
  accushieldPalette,
  petalPalette,
} from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors/chartColors.constants';

export function getChartColors(): ChartColorPalette {
  if (WhiteLabelAccessor.isAccushieldProvider) return accushieldPalette;
  if (WhiteLabelAccessor.isPetalProvider) return petalPalette;
  return bookjanePalette;
}

export function useChartColors(): ChartColorPalette {
  return useMemo(() => getChartColors(), []);
}
